import React from 'react';
import { INotificationData } from '../MobileAppTypes';
import { NotificationController } from './NotificationController';
import { FormatDate } from '../../../utils/Tools';
import Button from '../../_Core/Button';

interface INotificationItemProps {
  notification: INotificationData;
  onCancel: (notificationId: string) => void;
  isLoading?: boolean;
}

const NotificationItem: React.FC<INotificationItemProps> = ({ notification, onCancel, isLoading = false }) => {
  const notificationData = NotificationController.parseNotificationData(notification.Data);
  const status = NotificationController.getNotificationStatus(notification);
  const canCancel = NotificationController.canCancelNotification(notification);

  const handleCancel = () => {
    if (notification.PublicId && canCancel && !isLoading) {
      onCancel(notification.PublicId);
    }
  };

  const getStatusClassName = (status: string): string => {
    switch (status.toLowerCase()) {
      case 'sent':
        return 'notification-item__status--sent';
      case 'scheduled':
        return 'notification-item__status--scheduled';
      case 'pending':
        return 'notification-item__status--pending';
      default:
        return 'notification-item__status--draft';
    }
  };

  return (
    <div className="list-item">
      <div className="flex-between">
        <div>
          <h4 className="notification-item__title">{notificationData.title}</h4>
          {notification.CanceledAtUtc && <span className="label label-danger"> (Canceled)</span>}
        </div>
        <div>
          <span className={`notification-item__status ${getStatusClassName(status)}`}>{status}</span>
        </div>
      </div>

      <div className="notification-item__body">{notificationData.body}</div>

      <div className="notification-item__footer">
        <div className="flex-between">
          <div>
            <div>Created: {FormatDate(notification.CreatedAtUtc)}</div>
            {notification.Scheduled && notification.ScheduledForUtc && <div>Scheduled: {FormatDate(notification.ScheduledForUtc)}</div>}

            <div>
              Priority: <span style={{ textTransform: 'capitalize' }}>{notificationData.priority}</span>
            </div>
          </div>
          <div className='text-right'>
            
            {notification.Sent && notification.NumberSent !== undefined && <div>Recipients: {notification.NumberSent}</div>}
            {notification.Sent && notification.NumberOfDevices !== undefined && <div>Devices: {notification.NumberOfDevices}</div>}
            
            {notification.Sent && notification.NumberOfErrors !== undefined && notification.NumberOfErrors > 0 && (
              <div><span className='label label-warning'>Errors: {notification.NumberOfErrors}</span></div>
            )}

          </div>
        </div>

        <div className="notification-item__actions">{canCancel && <Button onClick={handleCancel} disabled={isLoading} title="Cancel" />}</div>
      </div>
    </div>
  );
};

export default NotificationItem;
